// import React, { useState } from 'react';
// import { Modal, Row, Col } from 'react-bootstrap';
// import { Stepper, Step, StepLabel } from '@mui/material';
// import SbCancelBtn, { SBSaveUpdateBtn } from '../../Buttons/Buttons';

// const steps = ['Method', ''];

// const AddRestDataSources = ({ open, handleCloseModal }) => {
//     const [activeStep, setActiveStep] = useState(0);
//     const [method, setMethod] = useState('from-scratch');

//     const handleNext = () => {
//         if (activeStep < steps.length - 1) {
//             setActiveStep((prevStep) => prevStep + 1);
//         } else {
//             handleCloseModal();
//         }
//     };

//     return (
//         <Modal show={open} onHide={handleCloseModal} className='add-customer-modal'>
//             <Modal.Header closeButton>
//                 <Modal.Title>Create REST Data Source - {steps[activeStep]}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 {/* Stepper */}
//                 <Stepper activeStep={activeStep} alternativeLabel>
//                     {steps.map((label, index) => (
//                         <Step key={label} className={activeStep === index ? 'step-active' : ''}>
//                             <StepLabel
//                             >
//                                 {label}
//                             </StepLabel>
//                         </Step>
//                     ))}
//                 </Stepper>

//                 {/* Step Content */}
//                 <Row className="mt-4">
//                     <Col>
//                         <p>When you create a new REST Data Source, you have two options. You can create a new REST Data Source from scratch or reuse implementations that already exist in your application.</p>
//                         <div>
//                             <input
//                                 type="radio"
//                                 id="from-scratch"
//                                 name="method"
//                                 value="from-scratch"
//                                 checked={method === 'from-scratch'}
//                                 onChange={() => setMethod('from-scratch')}
//                             />
//                             <label htmlFor="from-scratch" style={{ marginLeft: '8px' }}>From Scratch</label>
//                         </div>
//                         <div>
//                             <input
//                                 type="radio"
//                                 id="copy-existing"
//                                 name="method"
//                                 value="copy-existing"
//                                 checked={method === 'copy-existing'}
//                                 onChange={() => setMethod('copy-existing')}
//                             />
//                             <label htmlFor="copy-existing" style={{ marginLeft: '8px' }}>As a copy of an existing REST Data Source</label>
//                         </div>
//                     </Col>
//                 </Row>
//             </Modal.Body>
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseModal} />
//                 <SBSaveUpdateBtn btnName="Next" onClickEffect={handleNext} />
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default AddRestDataSources;




import React, { useRef, useState } from 'react';
import { Modal, Row, Col, Form, ToggleButton, ButtonGroup } from 'react-bootstrap';
import { Stepper, Step, StepLabel } from '@mui/material';
import SbCancelBtn, { SBPreviousBtn, SBSaveUpdateBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import attachmentImg from '../../../assets/images/attachmentImg.svg';
import PreviewComponent from './PreviewComponent';

const steps = ['Method', 'General',
    // 'Remote Server', 
    'Settings', 'Authentication', 'Parameters', 'Preview'];

// Dropdown options
const dataSourceOptions = [
    { value: 'SAP', label: 'SAP' },
    { value: 'Oracle', label: 'Oracle' }
];

const remoteServerOptions = [
    { value: 'create-new', label: 'Create New' },
    { value: 'existing-server-1', label: 'Existing Server 1' },
    { value: 'existing-server-2', label: 'Existing Server 2' }
];

const paginationOptions = [
    { value: 'No Pagination', label: 'No Pagination' },
    { value: 'Page Size and Fetch Offset', label: 'Page Size and Fetch Offset' },
    { value: 'Page Size and Page Number', label: 'Page Size and Page Number' },
    { value: 'Page Number', label: 'Page Number' }
];

const credentialOptions = [
    { value: 'user1', label: 'User 1' },
    { value: 'user2', label: 'User 2' }
];
const authenticationTypeOptions = [
    { value: 'Basic Authentication', label: 'Basic Authentication' },
    { value: 'OAuth2 Client Credentials', label: 'OAuth2 Client Credentials' },
    { value: 'OCI Native Authentication', label: 'OCI Native Authentication' },
    { value: 'HTTP Header', label: 'HTTP Header' },
    { value: 'URL Query String', label: 'URL Query String' },
];

const parameterOptions = [
    { value: 'Select', label: 'Select' },
    { value: 'URL Pattern', label: 'URL Pattern' },
    { value: 'URL Query String', label: 'URL Query String' },
    { value: 'HTTP Header', label: 'HTTP Header' },
    { value: 'HTTP Cookie', label: 'HTTP Cookie' },
]

const AddRestDataSources = ({ open, handleCloseModal }) => {

    const [activeStep, setActiveStep] = useState(0);
    const [method, setMethod] = useState('from-scratch');
    const [dataSourceType, setDataSourceType] = useState(dataSourceOptions[0]);
    const [remoteServer, setRemoteServer] = useState(remoteServerOptions[0]);
    const [name, setName] = useState('');
    const [urlEndpoint, setUrlEndpoint] = useState('');
    const [openApiUrl, setOpenApiUrl] = useState('');
    const [baseUrl, setBaseUrl] = useState('');
    const [serviceUrlPath, setServiceUrlPath] = useState('');
    const [paginationType, setPaginationType] = useState(paginationOptions[0]);
    const [parameterType, setParameterType] = useState('');
    const [toggleState, setToggleState] = useState(false);
    const [parameterTypeList, setParameterTypeList] = useState([]); // List of selected parameter options
    const [fieldsData, setFieldsData] = useState({}); // Store data for each parameter option
    const [postData, setPostData] = useState("");
    const [parameterFields, setParameterFields] = useState([
        { type: parameterOptions[0], name: "", value: "", isStatic: false },
    ]);

    // Authentication State
    const [authenticationRequired, setAuthenticationRequired] = useState(false);
    const [credential, setCredential] = useState(null);
    const [authenticationType, setAuthenticationType] = useState(null);

    // Function to go to the next step
    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevStep) => prevStep + 1);
        } else {
            handleCloseModal();
        }
    };

    // Function to go to the previous step
    const handleBackStep = () => {
        if (activeStep > 0) {
            setActiveStep((prevStep) => prevStep - 1);
        }
    };

    const handleAuthenticationToggle = () => {
        setAuthenticationRequired((prev) => !prev);
        if (!authenticationRequired) {
            // Reset authentication fields when disabled
            setCredential(null);
            setAuthenticationType(null);
        }
    };

    const handleCredentialChange = (selectedOption) => {
        setCredential(selectedOption);
    };

    const handleAuthenticationTypeChange = (selectedOption) => {
        setAuthenticationType(selectedOption);
    };

    // Handle parameter type change
    const handleParameterTypeChange = (selectedOption, index) => {
        if (selectedOption.value === "Select") {
            // Remove the field at the current index
            const updatedFields = parameterFields.filter((_, i) => i !== index);
            setParameterFields(updatedFields);
        } else {
            // Update the existing field
            const updatedFields = [...parameterFields];
            updatedFields[index] = { ...updatedFields[index], type: selectedOption };
            setParameterFields(updatedFields);

            // Add a new field only if this is the last one
            if (index === parameterFields.length - 1) {
                setParameterFields((prev) => [
                    ...prev,
                    { type: parameterOptions[0], name: "", value: "", isStatic: false },
                ]);
            }
        }
    };

    // Handle changes for specific fields
    const handleFieldChange = (index, field, value) => {
        const updatedFields = [...parameterFields];
        updatedFields[index][field] = value;
        setParameterFields(updatedFields);
    };

    const [methodType, setMethodType] = useState("GET"); // To manage the GET/POST toggle state

    // Update method type
    const handleMethodTypeChange = (method) => {
        setMethodType(method); // Update state
    };

    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);

    // Trigger file input click
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };

    // Handle file selection and upload
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file); // Store the selected file in the state
        }
    };

    return (
        <Modal show={open} onHide={handleCloseModal} backdrop="static" keyboard={false} className='add-rest-data-source-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Create REST Data Source - {steps[activeStep]}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Stepper */}
                <Stepper activeStep={activeStep} alternativeLabel className='rest-data-stepper m-4'>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                {/* Step 1: Method Selection */}
                {activeStep === 0 && (
                    <Row className="mt-4">
                        <Col>
                            <p>When you create a new REST Data Source, you have two options. You can create a new REST Data Source from scratch or you reuse implementations that already exist in your application or in other applications within your workspace.</p>
                            <div>
                                <input
                                    type="radio"
                                    id="from-scratch"
                                    name="method"
                                    value="from-scratch"
                                    checked={method === 'from-scratch'}
                                    onChange={() => setMethod('from-scratch')}
                                />
                                <label htmlFor="from-scratch" style={{ marginLeft: '8px' }}>From Scratch</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="copy-existing"
                                    name="method"
                                    value="copy-existing"
                                    checked={method === 'copy-existing'}
                                    onChange={() => setMethod('copy-existing')}
                                />
                                <label htmlFor="copy-existing" style={{ marginLeft: '8px' }}>Copy Existing REST Data Source</label>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* Step 2: General Form */}
                {activeStep === 1 && (
                    <Row className="mt-4">
                        <Col>
                            <Form>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group controlId="dataSourceType">
                                            <Form.Label>REST Data Source Type</Form.Label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={dataSourceOptions}
                                                value={dataSourceType}
                                                onChange={setDataSourceType}
                                                placeholder="Select"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="name">
                                            <Form.Label>Master Name <span style={{ color: 'red' }}>*</span></Form.Label>
                                            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group controlId="urlEndpoint" className="mt-3">
                                            <Form.Label>End Point URL<span style={{ color: 'red' }}>*</span></Form.Label>
                                            <Form.Control type="text" value={urlEndpoint} onChange={(e) => setUrlEndpoint(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                )}

                {/* Step 3: Remote Server */}
                {/* {activeStep === 2 && (
                    <Row className="mt-4">
                        <Col>
                            <Form>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group controlId="remoteServer">
                                            <Form.Label>Remote Server</Form.Label>
                                            <Select
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                options={remoteServerOptions}
                                                value={remoteServer}
                                                onChange={setRemoteServer}
                                                placeholder="Select Remote Server"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group controlId="baseUrl" className="mt-3">
                                            <Form.Label>Base URL <span style={{ color: 'red' }}>*</span></Form.Label>
                                            <Form.Control type="text" value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group controlId="serviceUrlPath" className="mt-3">
                                            <Form.Label>Service URL Path <span style={{ color: 'red' }}>*</span></Form.Label>
                                            <Form.Control type="text" value={serviceUrlPath} onChange={(e) => setServiceUrlPath(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                )} */}

                {/* Step 4: Settings */}
                {activeStep === 2 && (
                    <>
                        {paginationType && (
                            <Row className="mt-4">
                                <Col>
                                    <Form>
                                        {/* Pagination Type Dropdown */}
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group controlId="paginationType">
                                                    <Form.Label>Pagination Type</Form.Label>
                                                    <Select
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        options={paginationOptions}
                                                        value={paginationType}
                                                        onChange={setPaginationType}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Render fields dynamically based on pagination type */}
                                        {paginationType.value === "Page Size and Fetch Offset" && (
                                            <>
                                                <Row className='mt-3'>
                                                    <Col md={4}>
                                                        <Form.Group controlId="pageSizeURLParameter">
                                                            <Form.Label>Page Size URL Parameter</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="pageSizeMaximum">
                                                            <Form.Label>Page Size Maximum</Form.Label>
                                                            <Form.Control type="number" />
                                                        </Form.Group>

                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="rowOffsetURLParameter">
                                                            <Form.Label>Row Offset URL Parameter</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col md={4}>
                                                        <Form.Group controlId="rowOffsetType">
                                                            <Form.Label>Row Offset Type</Form.Label>
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                            // options={rowOffsetTypeOptions}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="hasMoreRowsSelector">
                                                            <Form.Label>Has More Rows Selector</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="totalRowsSelector">
                                                            <Form.Label>Total Rows Selector</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                        {paginationType.value === "Page Size and Page Number" && (
                                            <>
                                                <Row className='mt-3'>
                                                    <Col md={4}>
                                                        <Form.Group controlId="pageSizeURLParameter">
                                                            <Form.Label>Page Size URL Parameter</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>

                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="pageSizeMaximum">
                                                            <Form.Label>Page Size Maximum</Form.Label>
                                                            <Form.Control type="number" />
                                                        </Form.Group>

                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="pageNumberURLParameter">
                                                            <Form.Label>Page Number URL Parameter</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col md={4}>
                                                        <Form.Group controlId="indexOfFirstPage">
                                                            <Form.Label>Index of First Page</Form.Label>
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                            // options={indexOfFirstPageOptions}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="hasMoreRowsSelector">
                                                            <Form.Label>Has More Rows Selector</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="totalRowsSelector">
                                                            <Form.Label>Total Rows Selector</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                        {paginationType.value === "Page Number" && (
                                            <>
                                                <Row className='mt-3'>
                                                    <Col md={4}>
                                                        <Form.Group controlId="pageNumberURLParameter">
                                                            <Form.Label>Page Number URL Parameter</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="indexOfFirstPage">
                                                            <Form.Label>Index of First Page</Form.Label>
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                            // options={indexOfFirstPageOptions}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="fixedPageSize">
                                                            <Form.Label>Fixed Page Size</Form.Label>
                                                            <Form.Control type="number" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col md={4}>
                                                        <Form.Group controlId="hasMoreRowsSelector">
                                                            <Form.Label>Has More Rows Selector</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group controlId="totalRowsSelector">
                                                            <Form.Label>Total Rows Selector</Form.Label>
                                                            <Form.Control type="text" />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </Form>
                                </Col>
                            </Row>
                        )}
                    </>
                )}

                {/* Step 5: Authentication */}
                {activeStep === 3 && (
                    <Row className="mt-4">
                        <Col>
                            <Form>
                                <Form.Group controlId="authRequired" className='d-flex align-items-center pb-3'>
                                    <label className='mb-0 pe-2'>Authentication Required</label>
                                    {/* <div className="custom-toggle-switch">
                                        <input
                                            type="checkbox"
                                            className="custom-toggle-input"
                                            id="auth-switch"
                                            checked={authenticationRequired}
                                            onChange={handleAuthenticationToggle}
                                        />
                                        <label
                                            className={`custom-toggle-label ${authenticationRequired ? "enabled" : "disabled"}`}
                                            htmlFor='auth-switch'
                                        >
                                            {authenticationRequired ? "Enable" : "Disable"}
                                        </label>
                                    </div> */}
                                    <Form.Check
                                        type="switch"
                                        className='authentication-toggle'
                                        // id={`isStatic-switch-${index}`}
                                        checked={authenticationRequired}
                                        onChange={handleAuthenticationToggle}
                                    />
                                </Form.Group>

                                {authenticationRequired && (
                                    <>
                                        {/* <Row className='mt-3'>
                                            <Col md={12}>                                        <Form.Group controlId="credential">
                                                <Form.Label>Credential</Form.Label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    options={credentialOptions}
                                                    value={credential}
                                                    onChange={handleCredentialChange}
                                                />
                                            </Form.Group>
                                            </Col>
                                        </Row> */}
                                        <Row className='mt-3'>
                                            <Col md={12}>
                                                <Form.Group controlId="authenticationType">
                                                    <Form.Label>Authentication Type</Form.Label>
                                                    <Select
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        options={authenticationTypeOptions}
                                                        value={authenticationType}
                                                        onChange={handleAuthenticationTypeChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {/* Render fields based on the selected authentication type */}
                                        {authenticationType?.value === 'Basic Authentication' && (
                                            <Row className='mt-3'>
                                                <Col md={6}>
                                                    <Form.Group controlId="username">
                                                        <Form.Label>Username</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter username"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group controlId="password">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control
                                                            type="password"
                                                            placeholder="Enter password"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        )}

                                        {authenticationType?.value === 'OAuth2 Client Credentials' && (
                                            <>
                                                <Row className='mt-3'>
                                                    <Col md={12}>
                                                        <Form.Group controlId="oauthTokenUrl">
                                                            <Form.Label>OAuth Token URL</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter OAuth Token URL"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Row mt-3>
                                                    <Col md={6}>
                                                        <Form.Group controlId="clientId">
                                                            <Form.Label>Client ID</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter Client ID"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group controlId="clientSecret">
                                                            <Form.Label>Client Secret</Form.Label>
                                                            <Form.Control
                                                                type="password"
                                                                placeholder="Enter Client Secret"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                        {authenticationType?.value === 'OCI Native Authentication' && (
                                            <>
                                                <Row className='mt-3'>
                                                    <Col md={6}>
                                                        <Form.Group controlId="ociUserId">
                                                            <Form.Label>OCI User ID</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter OCI User ID"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group controlId="ociTenancyId">
                                                            <Form.Label>OCI Tenancy ID</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter OCI Tenancy ID"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col md={12}>
                                                        <Form.Group controlId="ociPrivateKey">
                                                            <Form.Label>OCI Private Key</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={3}
                                                                placeholder="Enter OCI Private Key"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col md={6}>
                                                        <Form.Group controlId="ociPublicKeyFingerprint">
                                                            <Form.Label>OCI Public Key Fingerprint</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter OCI Public Key Fingerprint"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                        {(authenticationType?.value === 'HTTP Header' || authenticationType?.value === 'URL Query String') && (
                                            <Row className='mt-3'>
                                                <Col md={6}>
                                                    <Form.Group controlId="name">
                                                        <Form.Label>Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Name"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group controlId="value">
                                                        <Form.Label>Value</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Value"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}
                            </Form>
                        </Col>
                    </Row>
                )}

                <>
                    {activeStep === 4 && (
                        <Row className="mt-4">
                            <Col>
                                <Form>
                                    {/* Initial fields */}
                                    {parameterFields.map((field, index) => (
                                        <Row className="mt-4" key={index}>
                                            <Col md={4}>
                                                <Form.Group controlId={`parameterType-${index}`}>
                                                    <Form.Label>Parameter Type</Form.Label>
                                                    <Select
                                                        className="react-select-container complaint-status-select"
                                                        classNamePrefix="react-select"
                                                        options={parameterOptions}
                                                        value={field.type}
                                                        onChange={(selectedOption) =>
                                                            handleParameterTypeChange(selectedOption, index)
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group controlId={`parameterName-${index}`}>
                                                    <Form.Label>Parameter Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={field.name}
                                                        onChange={(e) =>
                                                            handleFieldChange(index, "name", e.target.value)
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group controlId={`value-${index}`}>
                                                    <Form.Label>Value</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={field.value}
                                                        onChange={(e) =>
                                                            handleFieldChange(index, "value", e.target.value)
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={2} className="d-flex align-items-center">
                                                <Form.Group controlId={`isStatic-${index}`}>
                                                    <Form.Label>Is Static</Form.Label>
                                                    <Form.Check
                                                        type="switch"
                                                        id={`isStatic-switch-${index}`}
                                                        checked={field.isStatic}
                                                        onChange={(e) =>
                                                            handleFieldChange(index, "isStatic", e.target.checked)
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    ))}

                                    {/* Get/Post toggle in a new row */}
                                    <Row className='mt-3'>
                                        <Col>
                                            <Form>
                                                {/* Other fields */}
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group className="d-flex flex-column w-2">
                                                            <Form.Label className="mb-2">HTTP Method</Form.Label>
                                                            <ButtonGroup className='rest-data-get-post-toggle-btn-group' toggle>
                                                                <ToggleButton
                                                                    className='rest-data-get-post-toggle'
                                                                    key="GET"
                                                                    type="radio"
                                                                    variant={methodType === "GET" ? "primary" : "outline-primary"}
                                                                    name="method"
                                                                    value="GET"
                                                                    checked={methodType === "GET"}
                                                                    // onChange={(e) => setMethodType(e.currentTarget.value)}
                                                                    onClick={() => handleMethodTypeChange("GET")}
                                                                >
                                                                    GET
                                                                </ToggleButton>
                                                                <ToggleButton
                                                                    className='rest-data-get-post-toggle'
                                                                    key="POST"
                                                                    type="radio"
                                                                    variant={methodType === "POST" ? "primary" : "outline-primary"}
                                                                    name="method"
                                                                    value="POST"
                                                                    checked={methodType === "POST"}
                                                                    // onChange={(e) => setMethodType(e.currentTarget.value)}
                                                                    onClick={() => handleMethodTypeChange("POST")}
                                                                >
                                                                    POST
                                                                </ToggleButton>
                                                            </ButtonGroup>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6} className="d-flex justify-content-start align-items-end">
                                                        <div className="dropdown add-single-bulk attachment-section">
                                                            <label>Discovery Sample</label>
                                                            <button
                                                                className="btn btn-add-save-update attachment-btn"
                                                                id="adduser-single-blulk"
                                                                onClick={handleAttachmentClick}
                                                            >
                                                                <img src={attachmentImg} alt="" />&nbsp;&nbsp;
                                                                <span>Attachment</span>
                                                                <div className="attachment-note">
                                                                    <small>(jpg, PDF, word doc)</small>
                                                                </div>
                                                            </button>
                                                            <input
                                                                type="file"
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleFileChange}
                                                            />
                                                            {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Col>
                                    </Row>
                                    {/* Textarea for POST Method */}
                                    {methodType === "POST" && (
                                        <Row>
                                            <Col>
                                                <Form.Group controlId="postData">
                                                    <Form.Label>Request Body</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={4}
                                                        placeholder="Enter POST data here"
                                                        value={postData}
                                                        onChange={(e) => setPostData(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    )}
                                    {/* <Row>
                                        <Col md={12}>
                                            <Form.Group controlId="rowSelector">
                                                <Form.Label>Row Selector(leave empty for auto-detection)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row> */}
                                </Form>
                            </Col>
                        </Row>
                    )}
                </>
                <>
                    {activeStep === 5 && (<PreviewComponent />)}
                </>

            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseModal} />

                {/* Hide Previous button on Step 1 */}
                {activeStep > 0 && <SBPreviousBtn btnName="Previous" onClickEffect={handleBackStep} />}

                <SBSaveUpdateBtn btnName={activeStep === steps.length - 1 ? "Connect" : "Next"} onClickEffect={handleNext} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddRestDataSources;


